import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    //component: () => import('../views/Login/login.vue')
    //redirect: '/login',
    //component: Home
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next({path:'/inicio'})
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '*',
    //component: () => import('../views/Login/login.vue')
    //redirect: '/login',
    //component: Home
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next({path:'/inicio'})
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/login.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next({path:'/inicio'})
      }else{
        next()
      }
    }
  },
  {
    path: '/inicio',
    name: 'inicio',
    component: () => import('../views/Inicio/Inicio.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  /**========== MANTENEDORES ===============*/
  {
    path:'/empresas',
    name:'empresas',
    component: () => import('../views/Mantenedores/Empresa.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/sucursales',
    name:'sucursales',
    component: () => import('../views/Mantenedores/Dependencia.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tipo_sucursales',
    name:'tipo_sucursales',
    component: () => import('../views/Mantenedores/TipoDependencia.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/comunas',
    name:'comunas',
    component: () => import('../views/Mantenedores/Comuna.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/barcos',
    name:'barcos',
    component: () => import('../views/Mantenedores/Barco.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/muelles',
    name:'muelles',
    component: () => import('../views/Mantenedores/Muelle.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/materias_primas',
    name:'materias_primas',
    component: () => import('../views/Mantenedores/TipoMateriaPrima.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/subtipos_materiaprima',
    name:'subtipos_materiaprima',
    component: () => import('../views/Mantenedores/SubtipoMateriaPrima.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/conductores',
    name:'conductores',
    component: () => import('../views/Mantenedores/Conductor.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/especies',
    name:'especies',
    component: () => import('../views/Mantenedores/Especie.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/cargos',
    name:'cargos',
    component: () => import('../views/Mantenedores/Cargo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/talonarios',
    name:'talonarios',
    component: () => import('../views/Mantenedores/Talonario.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tarifas_transbordadores',
    name:'tarifas_transbordadores',
    component: () => import('../views/Mantenedores/TarifaTransbordador.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tipo_transportes',
    name:'tipo_transportes',
    component: () => import('../views/Mantenedores/TipoTransporte.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/transportes',
    name:'transportes',
    component: () => import('../views/Mantenedores/Camiones/Transporte.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/transportes/arriendos',
    name:'transportes_arriendos',
    component: () => import('../views/Mantenedores/Camiones/Arriendos.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/transportes/:transportes_id/tarifas',
    name:'transportes_tarifas',
    component: () => import('../views/Mantenedores/Camiones/Tarifa_Arriendo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/restricciones',
    name:'restricciones',
    component: () => import('../views/Mantenedores/Restriccion.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/pozos',
    name:'pozos',
    component: () => import('../views/Mantenedores/Pozos/Pozo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/pozos/stock',
    name:'pozos_stock_fecha',
    component: () => import('../views/Pozos/Stock.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/pozos/estados',
    name:'pozos_estados',
    component: () => import('../views/Mantenedores/Pozos/Estado.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/productos_despachos',
    name:'productos_despachos',
    component: () => import('../views/Mantenedores/DespachoProducto.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/cargas_petroleo',
    name:'cargas_petroleo',
    component: () => import('../views/Patio/CargaPetroleo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/cargas_petroleo_listado',
    name:'cargas_petroleo_listado',
    component: () => import('../views/Mantenedores/CargaPetroleo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/ingresos_petroleo',
    name:'ingresos_petroleo',
    component: () => import('../views/Patio/IngresoPetroleo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path:'/peajes',
    name:'peajes',
    component: () => import('../views/Mantenedores/Peaje.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tipo_vehiculo_peaje',
    name:'tipo_vehiculo_peaje',
    component: () => import('../views/Mantenedores/TipoVehiculoPeaje.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tramo_peaje',
    name:'tramo_peaje',
    component: () => import('../views/Mantenedores/TramoPeaje.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== MANTENEDORES ===============*/

  /**========== LABORATORIO ================ */
  {
    path:'/parametros',
    name:'parametros',
    component: () => import('../views/Laboratorio/LabParametro.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_parametros')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/item_analisis_mps',
    name:'item_analisis_mps',
    component: () => import('../views/Laboratorio/LabItemAnalisis.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_configuracion_parametros')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/analisis_tickets',
    name:'analisis_tickets',
    component: () => import('../views/Laboratorio/AnalisisTicket.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_analisis_laboratorio')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/item_parametros',
    name:'item_parametros',
    component: () => import('../views/Laboratorio/LabItemParametro.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== LABORATORIO ================ */


  /**========== INTEGRACION ===============*/
  {
    path:'/recepcion',
    name:'recepcion',
    //component: () => import('../views/Etruck/Recepcion.vue'),
    component: () => import('../views/Pesamatic/Recepcion.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_recepcion')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/despacho',
    name:'despacho',
    //component: () => import('../views/Etruck/Despacho.vue'),
    component: () => import('../views/Pesamatic/Despacho.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_despacho')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path:'/importar_info_centros',
    name:'importar_info_centros',
    component: () => import('../views/Etruck/ImportarInfoCentro.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path:'/update',
    name:'update',
    component: () => import('../views/Etruck/None.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== INTEGRACION ===============*/

  /**========== TICKETS ROMANA ===============*/
  {
    path:'/tickets',
    name:'tickets',
    component: () => import('../views/TicketRomana/TicketRomana.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_tickets')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/ticket/:id',
    name: 'ticket_detalle',
    component: () => import('../views/TicketRomana/Detalle.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_tickets_detalle')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/ticket/:id/laboratorio',
    name: 'ticket_analisis_lab',
    component: () => import('../views/TicketRomana/AnalisisLaboratorio.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_TicketRomanaController_crear_actualizar_analisis_ticket')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== TICKETS ROMANA ===============*/

  /**========== GUIAS ROMANA ===============*/
  {
    path:'/guias',
    name:'guias',
    component: () => import('../views/GuiaRomana/GuiaRomana.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_guias')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== GUIAS ROMANA ===============*/

  

  /**========== PATIO ===============*/
  /* {
    path:'/ticket_a_pozo',
    name:'ticket_a_pozo',
    component: () => import('../views/Patio/TicketAsignarPozo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  }, */
  {
    path:'/pantalla_patio',
    name:'pantalla_patio',
    component: () => import('../views/Patio/Pantalla.vue'),
    
  }, 
  /**========== PATIO ===============*/

  /**========== PROYECCIONES ===============*/
  {
    path:'/proyecciones',
    name:'proyecciones',
    component: () => import('../views/Proyeccion/Proyeccion.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_proyecciones')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/proyeccion/:id',
    name: 'proyeccion_detalle',
    component: () => import('../views/Proyeccion/Detalle.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_proyecciones_detalle')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== PROYECCIONES ===============*/


  /**========== REPORTES =================== */
  {
    path: '/reportes/recepcion_diaria',
    name: 'recepcion_diaria',
    component: () => import('../views/Reportes/MensualMateriaPrima.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_mensual_materia_prima')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/materia_prima_por_proveedor',
    name: 'materia_prima_por_proveedor',
    component: () => import('../views/Reportes/MateriaPrimaPorProveedor.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_materia_prima_proveedor')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/personalizado',
    name: 'reporte_personalizado',
    component: () => import('../views/Reportes/Personalizado.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_personalizado')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  //nuevo reporte carga petroleo\\
  {
    path: '/reportes/carga_petroleo',
    name: 'reporte_carga_petroleo',
    component: () => import('../views/Reportes/ReporteCargaPetroleo.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_carga_petroleo')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  //reporte vales colación/almuerzo
  {
    path: '/reportes/vale_almuerzo',
    name: 'reporte_vale_almuerzo',
    component: () => import('../views/Reportes/ReporteValeAlmuerzo.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_vale_almuerzo')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/vale_lavado',
    name: 'reporte_vale_lavado',
    component: () => import('../views/Reportes/ReporteValeLavado.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_vale_lavado')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/sernapesca',
    name: 'reporte_sernapesca',
    component: () => import('../views/Reportes/Sernapesca.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_sernapesca')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/trazabilidad',
    name: 'reporte_trazabilidad',
    component: () => import('../views/Reportes/ReporteTrazabilidad.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_trazabilidad')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path: '/reportes/consolidado',
    name: 'reporte_consolidado',
    component: () => import('../views/Reportes/Consolidado.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_consolidado')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/analisis_tickets',
    name: 'reporte_analisis_tickets',
    component: () => import('../views/Reportes/AnalisisTicket.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/despachos',
    name: 'reporte_despachos',
    component: () => import('../views/Reportes/Despachos.vue'),
    beforeEnter(to, from, next) {
      //if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        //next({path:`${from.fullPath}`});
      //}
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/despachos/productos',
    name: 'reporte_despachos_productos',
    component: () => import('../views/Reportes/DespachoResumenProducto.vue'),
    beforeEnter(to, from, next) {
      //if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        //next({path:`${from.fullPath}`});
      //}
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/folios_transbordadores',
    name: 'reportes_folios_transbordadores',
    component: () => import('../views/Reportes/ReporteFolioTransbordador.vue'),
    beforeEnter(to, from, next) {
      //if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        //next({path:`${from.fullPath}`});
      //}
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path: '/reportes/talonarios_transbordadores',
    name: 'reporte_talonarios_transbordador',
    component: () => import('../views/Reportes/ReporteTalonarioTransbordador.vue'),
    beforeEnter(to, from, next) {
      //if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        //next({path:`${from.fullPath}`});
      //}
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes/vueltas_camiones',
    name: 'reporte_viajes_camiones',
    component: () => import('../views/Reportes/VueltaCamionTarifa.vue'),
    beforeEnter(to, from, next) {
      //if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        //next({path:`${from.fullPath}`});
      //}
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path: '/reportes/arriendo_camiones',
    name: 'reporte_arriendo_camiones',
    component: () => import('../views/Reportes/ReporteCamionArriendo.vue'),
    beforeEnter(to, from, next) {
      //if(!permitir_acceso_rol('ROMANA_vista_reporte_analisis_tickets')){
        //next({path:`${from.fullPath}`});
      //}
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },

  {
    path: '/reportes/despacho_vertedero',
    name: 'reporte_despacho_vertedero',
    component: () => import('../views/Reportes/ReporteDespachoVertedero.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  
  /**========== REPORTES =================== */

  /**========== SINCRONIZAR TICKET DE PLP A ROMANA =================*/
  {
    path: '/sincronizar',
    name: 'sincronizar',
    component: () => import('../views/Sincronizar/Sincronizar.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== SINCRONIZAR TICKET DE PLP A ROMANA =================*/

  /**========== DISTRIBUCIONES DE MATERIA PRIMA =================*/
  {
    path: '/distribuciones_vertedero',
    name: 'distribuciones_vertedero',
    component: () => import('../views/Distribuciones/DistribucionVertedero.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_vista_distribucion_vertedero')){
        next({path:from.fullPath});
      }

      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/distribuciones_proceso',
    name: 'distribuciones_proceso',
    component: () => import('../views/Distribuciones/DistribucionProceso.vue'),
    beforeEnter(to, from, next) {

      if(!permitir_acceso_rol('ROMANA_vista_distribucion_proceso')){
        next({path:`${from.fullPath}`});
      }

      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/pozos_totem',
    name: 'pozos_totem',
    component: () => import('../views/Pozos/Totem.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/movimientos_salidas',
    name: 'movimientos_salidas',
    component: () => import('../views/Pozos/MovimientoPozoSalida.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== DISTRIBUCIONES DE MATERIA PRIMA =================*/

  /**========== CONFIGURACIONES =================*/
  {
    path: '/destinatarios',
    name: 'destinatarios',
    component: () => import('../views/Configuracion/Destinatarios.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_destinatarios_correos')){
        next({path:`${from.fullPath}`});
      }

      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/reportes_correos',
    name: 'reportes_correos',
    component: () => import('../views/Configuracion/ReporteCorreo.vue'),
    beforeEnter(to, from, next) {

      if(!permitir_acceso_rol('ROMANA_administrar_reportes_automaticos_correo')){
        next({path:`${from.fullPath}`});
      }

      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('../views/Configuracion/Usuarios.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_usuarios')){
        next({path:`${from.fullPath}`});
      }

      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/menus',
    name: 'menus',
    component: () => import('../views/Configuracion/Menu.vue'),
    beforeEnter(to, from, next) {

      if(!permitir_acceso_rol('ROMANA_administrar_menus')){
        next({path:`${from.fullPath}`});
      }

      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import('../views/Configuracion/Role.vue'),
    beforeEnter(to, from, next) {

      if(!permitir_acceso_rol('ROMANA_administrar_roles')){
        next({path:`${from.fullPath}`});
      }
      
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/permisos',
    name: 'permisos',
    component: () => import('../views/Configuracion/Permission.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_permisos')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/dato_adicional_guias',
    name:'dato_adicional_guias',
    component: () => import('../views/Mantenedores/DatoAdicional.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_administrar_dato_adicional_guias')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== CONFIGURACIONES =================*/


  /**========== VUELTAS CAMIONES =================*/
  {
    path:'/vueltas_camiones',
    name:'vueltas_camiones',
    component: () => import('../views/VueltaCamion/VueltaCamion.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/lavados_camiones',
    name:'lavados_camiones',
    component: () => import('../views/VueltaCamion/FolioLavado.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/vales_almuerzo',
    name:'vales_almuerzo',
    component: () => import('../views/VueltaCamion/ValeColacion.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== VUELTAS CAMIONES =================*/


  /**========== TARIFAS =================*/
  {
    path:'/tarifas_lavados',
    name:'tarifas_lavados',
    component: () => import('../views/Tarifas/TarifaLavado.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tarifas_colaciones',
    name:'tarifas_colaciones',
    component: () => import('../views/Tarifas/TarifaColacion.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tarifas_peajes',
    name:'tarifas_peajes',
    component: () => import('../views/Tarifas/TarifaPeaje.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/tarifas_petroleo',
    name:'tarifas_petroleo',
    component: () => import('../views/Tarifas/TarifaPetroleo.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== TARIFAS =================*/


  /**========== PROGRAMA RETIRO =================*/
  {
    path:'/programa_retiro/listado',
    name:'programa_retiro_listado',
    component: () => import('../views/ProgramaRetiro/ListadoProgramas.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/programa_retiro/generar/:id?',
    name:'programa_retiro_generar',
    component: () => import('../views/ProgramaRetiro/GenerarPrograma.vue'),
    props: true,
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
   
  {
    path:'/programa_retiro/importar',
    name:'programa_retiro_importar',
    component: () => import('../views/ProgramaRetiro/ImportarInformacion.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path:'/programa_retiro/:id',
    name:'programa_retiro_ver',
    component: () => import('../views/ProgramaRetiro/VerPrograma.vue'),
    beforeEnter(to, from, next) {
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== PROGRAMA RETIRO =================*/


  /**========== CERTIFICADO DISPOSICIÓN =================*/
  {
    path: '/certificado_disposicion/listado',
    name: 'certificado_disposicion_listado',
    component: () => import('../views/CertificadoDisposicion/ListadoCertificados.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_CERTIFICADO_DISPOSICION_ACCEDER')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  {
    path: '/certificado_disposicion',
    name: 'certificado_disposicion',
    component: () => import('../views/CertificadoDisposicion/CertificadoDisposicion.vue'),
    beforeEnter(to, from, next) {
      if(!permitir_acceso_rol('ROMANA_CERTIFICADO_DISPOSICION_ACCEDER')){
        next({path:`${from.fullPath}`});
      }
      if(store.state.autenticado){
        next()
      }else{
        next({path:'/login'})
      }
    }
  },
  /**========== CERTIFICADO DISPOSICIÓN =================*/
  {
    path: '/formularios_pcc',
    name: 'formularios_pcc',
    component: () => import('../views/FormularioPCC/Listado.vue'),
    
  },
]

const permitir_acceso_rol = (rol)=>{
  let permisos = store.state.permisos_rom;
  let idx = permisos.findIndex(r => r == rol);
  return idx == -1? false : true;
};

const router = new VueRouter({
  mode: 'history',
  //base: process.env.environment === 'development' ? '/' : '/romanav2/',
  base: process.env.environment === 'development' ? '/' : '/',
  //base: process.env.BASE_URL,
  routes
})



export default router
